import { State } from './type'

const state: State = {
    addState: false,
    detail: null
}

const mutations = {
    toggleMsgauditApplyAddState(state: { addState: boolean }, value: boolean) {
        state.addState = value
    },
    setMsgauditApplyDetail(
        state: { detail: null | Object },
        value: Object | null
    ) {
        state.detail = value
    
}
}

export default {
    state,
    mutations,
}
